/*************************************************/
/* Partials                                      */
/*************************************************/
import { mmenu } from "./partials/mmenu.js";

/*************************************************/
/* Init                                          */
/*************************************************/

const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {
    mmenu();
});
